module.exports = __webpack_public_path__ + "static/media/search.671f67e9.svg";